// extracted by mini-css-extract-plugin
export default {"container":"QzFcoS1fZ82A42WhY2ww","mainContent":"M049_uRfdX6NXwtdeCQr","chatSuggestionsContainer":"tMN8TDzJn6JxPLawuAwM"};